import React, {
  memo,
  useState,
  forwardRef,
  useMemo,
  useRef,
  useCallback,
  useEffect,
  useImperativeHandle,
} from "react";
import { WithErrorHandler } from "newcar-ui/output/cjs/components/WithErrorHandler";
import { tools } from "newcar-ui/output/cjs/utils";
import "./index.scss";
const BaseInput = forwardRef((props, ref) => {
  const inputRef = useRef(null);
  useImperativeHandle(
    ref,
    () => {
      return {
        setInputFocus: () => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        },
        setInputBlurs: () => {
          if (inputRef.current) {
            inputRef.current.blur();
          }
        },
      };
    },
    [inputRef]
  );

  const labelStr = useMemo(() => props.labelStr || "", [props.disabled]);
  const disabled = useMemo(() => props.disabled || false, [props.disabled]);
  const placeholder = useMemo(
    () => props.placeholder || "",
    [props.placeholder]
  );
  const type = useMemo(() => props.type || "text", [props.type]);
  const defaultVal = useMemo(() => props.defaultVal || "", [props.defaultVal]);
  const maxLength = useMemo(() => props.maxLength, [props.maxLength]);
  const onChangeVal = useCallback((e) => {
    const val = e.target.value;
    if (typeof props.onChange !== "undefined") {
      props.onChange(val);
    }
  }, []);
  const onBlurIpt = useCallback(
    (e) => {
      const val = e.target.value;
      if (typeof props.onBlur !== "undefined") {
        props.onBlur(val);
      }
    },
    [props.onBlur]
  );

  const onFocusIpt = useCallback(() => {
    if (typeof props.onFocus !== "undefined") {
      props.onFocus();
    }
  }, [props.onFocus]);

  return (
    <div className="newbrand-input-wrap">
      {labelStr && <label>{labelStr}</label>}
      <input
        type={type}
        onChange={onChangeVal}
        defaultValue={defaultVal}
        placeholder={placeholder}
        onBlur={onBlurIpt}
        maxLength={maxLength}
        onFocus={onFocusIpt}
        ref={inputRef}
        disabled={disabled}
      />
    </div>
  );
});

const NameBaseInput = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      setInputFocus: () => {
        if (inputRef.current) {
          inputRef.current.setInputFocus();
        }
      },
      setInputBlurs: () => {
        if (inputRef.current) {
          inputRef.current.setInputBlurs();
        }
      },
    };
  });

  const { isBlurCheck } = useMemo(() => {
    return {
      isBlurCheck: props.isBlurCheck || true,
    };
  }, [props]);

  const inputRef = useRef();

  const onBlur = useCallback(
    (val) => {
      // 失去焦点的时候验证数据
      if (val && isBlurCheck) {
        if (typeof props.inBlurAutocheck !== "undefined") {
          props.inBlurAutocheck();
        } else if (!tools.onlyChinese(val)) {
          props.onError && props.onError();
        }
      }
      if (typeof props.onBlur !== "undefined") {
        props.onBlur(val);
      }
    },
    [props.onBlur]
  );

  return (
    <>
      <BaseInput
        type="text"
        labelStr={props.labelStr || "姓名"}
        onBlur={onBlur}
        placeholder={props.placeholder || "请输入您的姓名"}
        ref={inputRef}
        {...props}
      />
    </>
  );
});

const TelBaseInput = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      setInputFocus: () => {
        if (inputRef.current) {
          inputRef.current.setInputFocus();
        }
      },
      setInputBlurs: () => {
        if (inputRef.current) {
          inputRef.current.setInputBlurs();
        }
      },
    };
  });
  const inputRef = useRef();
  const { isBlurCheck } = useMemo(() => {
    return {
      isBlurCheck: props.isBlurCheck || true,
    };
  }, [props]);
  const onBlur = useCallback(
    (val) => {
      // 失去焦点的时候验证数据
      if (val && isBlurCheck) {
        if (typeof props.inBlurAutocheck !== "undefined") {
          props.inBlurAutocheck();
        } else if (!tools.isMobile(val)) {
          props.onError && props.onError();
        }
      }
      if (typeof props.onBlur !== "undefined") {
        props.onBlur(val);
      }
    },
    [props]
  );
  return (
    <>
      <BaseInput
        type="tel"
        maxLength={11}
        labelStr={props.labelStr || "电话"}
        placeholder={props.placeholder || "请输入您的电话号码"}
        onBlur={onBlur}
        ref={inputRef}
        {...props}
      />
    </>
  );
});

const AgreePrivacyCom = (props) => {
  const disabled = useMemo(() => props.disabled || false, [props.disabled]);
  const [isChecked, setIsChecked] = useState(() => {
    if (props.checked) {
      return props.checked;
    }
    return false;
  });
  /** 隐私协议地址 */
  const privacyAdd = useMemo(() => {
    return {
      m: "//m.58che.com/home.php?c=Dealer_AskPrice&a=Privacy",
      app: "//appsm.58che.com/58/privacy.html",
    };
  }, []);
  useEffect(() => {
    if (typeof props.getCheckStatus !== "undefined") {
      props.getCheckStatus(isChecked);
    }
  }, [isChecked]);

  const onChangeChecked = useCallback(
    (e) => {
      if (disabled) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      setIsChecked(!isChecked);
    },
    [isChecked, disabled]
  );
  return (
    <div className="brand-agreement">
      <span
        className={`radio ${isChecked ? "active" : ""}`}
        onClick={(e) => onChangeChecked(e)}
      ></span>
      <span className="agreement-text">
        我已阅读并同意{" "}
        <a href={tools.is58App() ? privacyAdd.app : privacyAdd.m}>
          《隐私协议》
        </a>
      </span>
    </div>
  );
};
const SelectComponent = WithErrorHandler(
  memo((props) => {
    const { labelStr, placeholder, val, onClick, className } = props;
    return (
      <div className={`newbrand-input-wrap ${className}`}>
        {labelStr && <label>{labelStr}</label>}
        <b className={`selectFont ${val ? "" : "default"}`} onClick={onClick}>
          {val ? val : placeholder}
        </b>
      </div>
    );
  })
);
SelectComponent.defaultProps = {
  labelStr: "意向车型",
  placeholder: "请选择您喜欢的车型",
  val: "",
  onClick: () => {
    console.log("change");
  },
  className: "",
};
const NameInput = WithErrorHandler(memo(NameBaseInput));
const TelInput = WithErrorHandler(memo(TelBaseInput));
const AgreePrivacy = WithErrorHandler(memo(AgreePrivacyCom));

export { NameInput, TelInput, AgreePrivacy, SelectComponent };
